import { CustomerPaymentProfile } from "@aus/Services/AusApiModels";
import { CarrierDto, CartModel, CollectAccountCollection } from "@insite/client-framework/Types/ApiModels";

const carrierCollectAccountsKey = "carrierCollectAccounts";

export function MapCollectAccounts(cart: CartModel) {
    if (cart!.properties[carrierCollectAccountsKey]) {
        const carrierCollectAccounts = JSON.parse(
            cart!.properties[carrierCollectAccountsKey],
        ) as CollectAccountCollection[];
        const carrierLookup: { [carrierId: string]: CarrierDto } = {};
        for (const carrier of cart.carriers ?? []) {
            if (carrier.id) {
                carrierLookup[carrier.id] = carrier;
            }
        }

        for (const collectAccount of carrierCollectAccounts) {
            if (collectAccount) {
                if (collectAccount.CarrierId) {
                    const carrier = carrierLookup[collectAccount.CarrierId];
                    carrier.collectAccounts = collectAccount.CollectAccounts;
                    if ((cart.carrier?.id ?? null) === collectAccount.CarrierId && cart.carrier) {
                        cart.carrier.collectAccounts = collectAccount.CollectAccounts;
                    }
                }
            }
        }

        delete cart.properties[carrierCollectAccountsKey];
    }
}

const storedCreditCardOptionsKey = "storedCreditCardOptions";

export function MapCustomerPaymentProfiles(cart: CartModel) {
    if (cart!.properties[storedCreditCardOptionsKey]) {
        const customerPaymentProfiles = JSON.parse(
            cart!.properties[storedCreditCardOptionsKey],
        ) as CustomerPaymentProfile[];

        if (customerPaymentProfiles && customerPaymentProfiles.length > 0) {
            cart.customerPaymentProfiles = customerPaymentProfiles;
        }

        delete cart!.properties[storedCreditCardOptionsKey];
    }
}
